import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  public credentials: { username: string; password: string; } = {
    username: '',
    password: '',
  };
  public errMsg: string = '';
  public isLoginError: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  public login() {
    const validation = this.validateFields();
    if (!validation) {
      console.log('Valid credentials? ', validation);
      this.isLoginError = true;
      this.errMsg = 'Invalid credentials.';
      return;
    }

    this.authService.login(this.credentials).subscribe({
      next: () => {
        this.router.navigate(['/']);
        this.isLoginError = false;
      },
      error: (err) => {
        console.error('Login error: ', err);
        this.isLoginError = true;
        (err && err.error && err.error.message) ? this.errMsg = err.error.message : this.errMsg = 'Login error: An error occurred.'
        // console.log('Error msg (login): ', this.errMsg);
      },
    });
  }

  private validateFields(): boolean {
    if (this.credentials.username === '' || this.credentials.password === '') {
      return false;
    }
    return true;
  }

}
